module.exports = __webpack_public_path__ + "img/Multimedia.3f00dee3.jpg";